<div class="revenue-page">

  <h2 class="page-title">
    Merchant Revenue Dashboard
  </h2>

  <div class="revenue-cards">

    <div class="revenue-card">

      <h4>Today Revenue</h4>

      <h2>₹{{todayRevenue?.received || 0}}</h2>

      <p>Bookings: {{todayRevenue?.count || 0}}</p>

    </div>


    <div class="revenue-card">

      <h4>Monthly Revenue</h4>

      <h2>₹{{monthlyRevenue?.received || 0}}</h2>

      <p>Bookings: {{monthlyRevenue?.count || 0}}</p>

    </div>


    <div class="revenue-card">

      <h4>Yearly Revenue</h4>

      <h2>₹{{yearlyRevenue?.received || 0}}</h2>

      <p>Bookings: {{yearlyRevenue?.count || 0}}</p>

    </div>

  </div>


  <div class="summary-card">

    <h3>Total Revenue Summary</h3>

    <div class="summary-grid">

      <div>

        <p>Received</p>

        <h2>₹{{totalRevenue?.received || 0}}</h2>

      </div>

      <div>

        <p>Pending</p>

        <h2>₹{{totalRevenue?.pending || 0}}</h2>

      </div>

    </div>

  </div>


  <div class="service-card">

    <h3>Service Revenue</h3>

    <div class="service-row" *ngFor="let service of totalRevenue?.serviceRevenue | keyvalue">

      <span>{{service.key}}</span>

      <strong>₹{{service.value}}</strong>

    </div>

  </div>


  <div class="chart-card">

    <div class="chart-selector">

      <button (click)="changeChart('service')">
        Service Revenue
      </button>

      <button (click)="changeChart('monthly')">
        Monthly Revenue
      </button>

      <button (click)="changeChart('yearly')">
        Yearly Revenue
      </button>

    </div>


    <div class="chart-card" *ngIf="selectedChart === 'service'">

      <h3>Service Revenue Chart</h3>

      <canvas baseChart [data]="serviceChartData" [options]="serviceChartOptions" [type]="'bar'">
      </canvas>

    </div>
    <div class="chart-card" *ngIf="selectedChart === 'monthly'">

      <h3>
        Monthly Revenue Trend
      </h3>

      <canvas baseChart [data]="monthlyChartData" [options]="monthlyChartOptions" [type]="'line'">
      </canvas>

    </div>
    <div class="chart-card" *ngIf="selectedChart === 'yearly'">

      <h3>
        Yearly Revenue
      </h3>

      <canvas baseChart [data]="yearlyChartData" [options]="yearlyChartOptions" [type]="'bar'">
      </canvas>

    </div>

  </div>